export const MAX_CROSS_SELLING_ITEM_COUNT = 8;
export const MAX_CART_CROSS_SELLING_ITEM_COUNT = 3;
